// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/es7.map.from.js
// module id = 216
// module chunks = 0 1